import { createClient } from '@sanity/client';

export const client = createClient({
  projectId: 'ayusbkq1',  // from your screenshot
  dataset: 'production',
  apiVersion: '2024-01-01',
  useCdn: true
});

